/* eslint-disable react/destructuring-assignment, no-nested-ternary */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { AuthenticationState } from 'bernie-context';
import { PickerTriggerPlacementType } from '@shared-ui/global-navigation-picker';
import { UitkMenu, UitkMenuContainer, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkIconSize, UitkIcon } from 'uitk-react-icons';
import { Viewport, ViewLarge, ViewSmall, ViewMedium, ViewExtraLarge, defaultViewSizes } from '@shared-ui/viewport-context';
import { usePlatformContext } from '@bernie/platform-context';
import { inject, observer } from 'mobx-react';
import { runInAction } from 'mobx';
import { UitkPrimaryButton, UitkTertiaryButton, UitkButtonSize } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { ExperimentControl, Experiment, ExperimentVariant, useExperiment } from '@shared-ui/experiment-context';
import { MemberWallet } from '@shared-ui/global-navigation-member-wallet';
import { LoyaltyMemberStatus } from '@shared-ui/global-navigation-loyalty';
import { UitkMemberBadge, UitkBadgeTheme } from 'uitk-react-badge';
import { UitkSpacing } from 'uitk-react-spacing';
import { HeaderSignedInHeading } from './header-signed-in-heading';
import { HeaderAccountMenuLanguages } from './header-account-menu-languages';
import { HeaderAccountMenuOneKey } from './header-account-menu-one-key';
import { HeaderGuestHeading, redirectGssUrl } from './header-guest-heading';
import { getComponentsByViewport, isRuleApplicable, toMenuItem } from '../gc-section-data';
import { SharedUIPickerWrapper } from '../../common/picker/shared-ui-picker-wrapper';
import { GcHeaderCustomMenuListItem } from '../../common/menu/index';
import { isPartnerHeaderTemplate } from '../../../common/utils/partner-utils';
import { TemplateId } from '../../../../types/common';
export var HeaderAccountMenu = function (props) {
    var context = usePlatformContext().context;
    var partnerUserStateExpActiveExposure = useExperiment('PWA_EPS_UserStateDifferentiation_Header').exposure;
    return React.createElement(HeaderAccountMenuClassComponent, __assign({}, props, { context: context, partnerUserStateExpActiveExposure: partnerUserStateExpActiveExposure }));
};
var HeaderAccountMenuClassComponent = /** @class */ (function (_super) {
    __extends(HeaderAccountMenuClassComponent, _super);
    function HeaderAccountMenuClassComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: _this.shouldOpen()
        };
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    HeaderAccountMenuClassComponent.prototype.shouldOpen = function () {
        var _a, _b;
        return (_b = (_a = this.props.globalComponentsContext) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.accountMenuShouldOpen;
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    HeaderAccountMenuClassComponent.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this.props, context = _d.context, analytics = _d.analytics, page = _d.page, l10n = _d.l10n, menuTriggerLabelText = _d.menuTriggerLabelText, menu = _d.menu, globalComponentsContext = _d.globalComponentsContext, partnerUserStateExpActiveExposure = _d.partnerUserStateExpActiveExposure;
        var user = context.user;
        var isUserAnonymous = user && user.authState === AuthenticationState.ANONYMOUS;
        var isSignedInUser = !isUserAnonymous;
        if (partnerUserStateExpActiveExposure.bucket === 1 && isPartnerHeaderTemplate(globalComponentsContext)
            && (user === null || user === void 0 ? void 0 : user.authState) === AuthenticationState.IDENTIFIED) {
            isSignedInUser = false;
        }
        var isSua = globalComponentsContext && globalComponentsContext.isSua;
        var gssSigninRedirectParam = ((_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _a === void 0 ? void 0 : _a.gssSigninRedirectParam) || '&uurl=e3id%3Dredr%26rurl%3D';
        var loyalty = globalComponentsContext.loyalty;
        var tierString = (loyalty === null || loyalty === void 0 ? void 0 : loyalty.tierString) || '';
        var formattedAccountInfo = (loyalty === null || loyalty === void 0 ? void 0 : loyalty.accountInfoString) || null;
        var menuTriggerAnalytics = analytics.setupTracker('Header.AccountHeading', 'Expand account dropdown');
        var menuItems = menu.data;
        var guestHeadingText = '';
        var headerMenuIllustrationUrl;
        var guestSubheadingText = (_c = (_b = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _b === void 0 ? void 0 : _b.guestMenuSubheading) !== null && _c !== void 0 ? _c : '';
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var setMenuItemOrSeparator = function (item, index) {
            if (item.type === 'menuitem') {
                var url = item.url;
                if (item.id === 'header-partner-services') {
                    var pageName = (page && page.pageName) ? page.pageName : 'HomePage';
                    if (item.url.includes('{PAGE_NAME}')) {
                        url = item.url.replace('{PAGE_NAME}', pageName);
                    }
                    else {
                        url = item.url.replace('utm_campaign=pwa-header', "utm_campaign=".concat(pageName));
                    }
                }
                return {
                    analytics: analytics.setupTracker(item.trackingEvent),
                    className: 'uitk-list-item',
                    label: item.text,
                    href: url,
                    openInNewTab: item.newWindow,
                    typeAnchor: true,
                    attributes: {
                        role: 'menuitem',
                        tabindex: 0
                    },
                    icon: item.iconName,
                    id: item.id,
                    menuItemSection: item && item.menuItemSection,
                    applicableRules: item.applicableRules
                };
            }
            return {
                id: "separator-".concat(index),
                label: undefined,
                href: undefined,
                className: 'uitk-list-divider',
                typeAnchor: false,
                attributes: {
                    role: item.type
                }
            };
        };
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var menuItemOrSeparator = function (item) { return item.type === 'menuitem' || item.type === 'separator'; };
        var acctMenuLinks = menuItems.filter(menuItemOrSeparator).map(setMenuItemOrSeparator);
        var isPickerEnabled = menuItems.some(function (link) { return link.id === 'picker'; });
        var signOutItems = [];
        var buttons = [];
        var buttonsKeysPosition = {};
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        var getButtonType = function (type, id) {
            switch (type) {
                case 'button-primary':
                    return UitkPrimaryButton;
                case 'button-tertiary':
                    return UitkTertiaryButton;
                case 'button':
                    return id === 'account-signin' || id === 'account-owner-signin' ? UitkPrimaryButton : UitkTertiaryButton;
                default:
                    return UitkPrimaryButton;
            }
        };
        // Add signout if authed user or non-sua
        if (isSignedInUser && !isSua) {
            var signOutIndex = acctMenuLinks.findIndex(function (link) { return link.id === 'account-signout'; });
            if (signOutIndex >= 0) {
                var signOutElement = acctMenuLinks[signOutIndex];
                var signOutRedirectUrl = redirectGssUrl(signOutElement.href, gssSigninRedirectParam, context, true);
                signOutElement.href = signOutRedirectUrl;
                acctMenuLinks.splice(signOutIndex, 1);
                signOutItems.push(signOutElement);
            }
        }
        else {
            menuItems.forEach(function (item) {
                switch (item.id) {
                    case 'guest-menu-heading':
                        guestHeadingText = item.text;
                        break;
                    case 'header-menu-illustration':
                        headerMenuIllustrationUrl = item.url;
                        break;
                    case 'account-signin':
                        buttonsKeysPosition[item.id] = buttons.length;
                        buttons.push({
                            url: item.url,
                            text: item.text,
                            id: item.id,
                            trackingEvent: item.trackingEvent,
                            hasAccountAlready: true,
                            linkName: 'Sign In',
                            stid: 'link-header-account-signin',
                            type: getButtonType(item.type, item.id)
                        });
                        break;
                    case 'account-owner-signin':
                        buttonsKeysPosition[item.id] = buttons.length;
                        buttons.push({
                            url: item.url,
                            text: item.text,
                            id: item.id,
                            trackingEvent: item.trackingEvent,
                            hasAccountAlready: true,
                            linkName: 'Owner Login',
                            stid: 'link-header-account-owner-signin',
                            type: getButtonType(item.type, item.id)
                        });
                        break;
                    case 'account-register':
                        buttonsKeysPosition[item.id] = buttons.length;
                        buttons.push({
                            url: item.url,
                            text: item.text,
                            id: item.id,
                            trackingEvent: item.trackingEvent,
                            hasAccountAlready: false,
                            linkName: 'Create Account',
                            stid: 'link-header-account-signup',
                            type: getButtonType(item.type, item.id)
                        });
                        break;
                    default:
                        break;
                }
            });
        }
        var localeOptions = this.props.globalComponentsContext.localeOptions;
        var applicableMenuProps = {
            context: context,
            globalComponentsContext: globalComponentsContext,
            position: this.props.position,
            isSignedInUser: isSignedInUser,
            menuTriggerAnalytics: menuTriggerAnalytics,
            l10n: l10n,
            menuTriggerText: null,
            acctMenuLinks: acctMenuLinks,
            signOutItems: signOutItems,
            localeOptions: localeOptions || [],
            tierString: tierString,
            headerMenuIllustrationUrl: headerMenuIllustrationUrl,
            guestHeadingText: guestHeadingText,
            guestSubheadingText: guestSubheadingText,
            buttons: buttons,
            buttonsKeysPosition: buttonsKeysPosition,
            isOpen: this.state.isOpen,
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            onTriggerClick: function () {
                var _a, _b;
                var isOpen = _this.state.isOpen;
                _this.setState({ isOpen: !isOpen });
                if ((_b = (_a = _this.props.globalComponentsContext) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.accountMenuShouldOpen) {
                    // eslint-disable-next-line no-return-assign
                    runInAction(function () { return _this.props.globalComponentsContext.header.accountMenuShouldOpen = false; });
                }
            },
            showText: true,
            showIcon: true,
            isPickerEnabled: isPickerEnabled
        };
        return (React.createElement(Viewport, null,
            React.createElement(ViewSmall, null,
                React.createElement(ApplicableMenu, __assign({}, applicableMenuProps, { acctMenuLinks: getComponentsByViewport(acctMenuLinks, defaultViewSizes.SMALL), showText: isRuleApplicable(menu, 'showText', defaultViewSizes.SMALL) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.SMALL), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.SMALL) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.SMALL) }))),
            React.createElement(ViewMedium, null,
                React.createElement(ApplicableMenu, __assign({}, applicableMenuProps, { acctMenuLinks: getComponentsByViewport(acctMenuLinks, defaultViewSizes.MEDIUM), showText: isRuleApplicable(menu, 'showText', defaultViewSizes.MEDIUM) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.MEDIUM), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.MEDIUM) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.MEDIUM) }))),
            React.createElement(ViewLarge, null,
                React.createElement(ApplicableMenu, __assign({}, applicableMenuProps, { menuTriggerText: !isSignedInUser
                        ? menuTriggerLabelText || l10n.accountAccountTriggerLabelText
                        : formattedAccountInfo == null ? (globalComponentsContext.firstName || l10n.accountDropDownMenuLinkText) : formattedAccountInfo, acctMenuLinks: getComponentsByViewport(acctMenuLinks, defaultViewSizes.LARGE), showText: isRuleApplicable(menu, 'showText', defaultViewSizes.LARGE) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.LARGE), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.LARGE) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.LARGE) }))),
            React.createElement(ViewExtraLarge, null,
                React.createElement(ApplicableMenu, __assign({}, applicableMenuProps, { menuTriggerText: !isSignedInUser
                        ? menuTriggerLabelText || l10n.accountAccountTriggerLabelText
                        : formattedAccountInfo == null ? (globalComponentsContext.firstName || l10n.accountDropDownMenuLinkText) : formattedAccountInfo, acctMenuLinks: getComponentsByViewport(acctMenuLinks, defaultViewSizes.EXTRA_LARGE), showText: isRuleApplicable(menu, 'showText', defaultViewSizes.EXTRA_LARGE) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.EXTRA_LARGE), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.EXTRA_LARGE) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.EXTRA_LARGE) })))));
    };
    HeaderAccountMenuClassComponent = __decorate([
        inject('globalComponentsContext'),
        observer
    ], HeaderAccountMenuClassComponent);
    return HeaderAccountMenuClassComponent;
}(React.Component));
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var LoyaltyStatusBadge = function (_a) {
    var tierStatus = _a.tierStatus, menuTriggerText = _a.menuTriggerText;
    var tierText;
    var badgeTheme;
    if (tierStatus.includes('Gold')) {
        tierText = 'Gold';
        badgeTheme = UitkBadgeTheme.LOYALTY_MIDDLE_TIER;
    }
    else if (tierStatus.includes('Silver')) {
        tierText = 'Silver';
        badgeTheme = UitkBadgeTheme.LOYALTY_LOW_TIER;
    }
    else if (tierStatus.includes('Platinum')) {
        tierText = 'Platinum';
        badgeTheme = UitkBadgeTheme.LOYALTY_HIGH_TIER;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Experiment, { name: "Orbitz_Loyalty_Badge" },
            React.createElement(ExperimentControl, null,
                React.createElement(UitkText, { size: 300 }, menuTriggerText)),
            React.createElement(ExperimentVariant, { bucket: 1 },
                React.createElement(UitkSpacing, { margin: { inlineend: 'one' } },
                    React.createElement(UitkMemberBadge, { className: "loyalty-badge", theme: badgeTheme, text: tierText })),
                React.createElement(UitkText, { size: 300 }, menuTriggerText)))));
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var ApplicableMenu = function (_a) {
    var _b, _c, _d;
    var context = _a.context, globalComponentsContext = _a.globalComponentsContext, position = _a.position, isSignedInUser = _a.isSignedInUser, menuTriggerAnalytics = _a.menuTriggerAnalytics, l10n = _a.l10n, menuTriggerText = _a.menuTriggerText, acctMenuLinks = _a.acctMenuLinks, signOutItems = _a.signOutItems, localeOptions = _a.localeOptions, tierString = _a.tierString, headerMenuIllustrationUrl = _a.headerMenuIllustrationUrl, guestHeadingText = _a.guestHeadingText, guestSubheadingText = _a.guestSubheadingText, buttons = _a.buttons, buttonsKeysPosition = _a.buttonsKeysPosition, isOpen = _a.isOpen, onTriggerClick = _a.onTriggerClick, showText = _a.showText, showIcon = _a.showIcon, isPickerEnabled = _a.isPickerEnabled;
    var isSua = globalComponentsContext && globalComponentsContext.isSua;
    var siteId = context && context.site && context.site.id;
    var isBexHeaderTemplate = globalComponentsContext
        && globalComponentsContext.header
        && globalComponentsContext.header.templateId === TemplateId.BEXHeader.valueOf();
    var CA_POS = 4;
    var displayAlternativeLocale = siteId === CA_POS;
    var gssSigninRedirectParam = ((_b = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _b === void 0 ? void 0 : _b.gssSigninRedirectParam) || '&uurl=e3id%3Dredr%26rurl%3D';
    var isLoyaltyPointsDisplayed = ((_c = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _c === void 0 ? void 0 : _c.loyaltyPointsDisplayed) || false;
    var loyalty = globalComponentsContext.loyalty;
    var formattedAccountInfo = (loyalty === null || loyalty === void 0 ? void 0 : loyalty.accountInfoString) || (globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.firstName);
    var isUserAuthenticated = context.user.authState === AuthenticationState.AUTHENTICATED;
    var signInButton = buttons[buttonsKeysPosition['account-signin']];
    var isSignInPresent = (signInButton === null || signInButton === void 0 ? void 0 : signInButton.id) === 'account-signin' && (signInButton === null || signInButton === void 0 ? void 0 : signInButton.url) && (signInButton === null || signInButton === void 0 ? void 0 : signInButton.text) && (signInButton === null || signInButton === void 0 ? void 0 : signInButton.type);
    var buttonText = (showText && menuTriggerText) ? (isSignedInUser && tierString
        ? React.createElement(LoyaltyStatusBadge, { tierStatus: tierString, menuTriggerText: menuTriggerText })
        : menuTriggerText)
        : null;
    var menuTriggerProps = {
        analytics: menuTriggerAnalytics,
        // eslint-disable-next-line no-nested-ternary
    };
    var iconProps = {
        title: l10n.accountDropDownMenuLinkText,
        id: 'account-menu-icon',
        name: 'account_circle',
        size: UitkIconSize.MEDIUM
    };
    var basicButton = (React.createElement(UitkTertiaryButton, __assign({ tabIndex: 0 }, menuTriggerProps),
        showIcon && React.createElement(UitkIcon, __assign({}, iconProps)),
        buttonText));
    var buttonTextComponent = (showText && menuTriggerText) ? basicButton : (React.createElement(UitkSpacing, { padding: { inline: 'three' } }, basicButton));
    return (React.createElement(React.Fragment, null,
        React.createElement(UitkMenu, { id: "gc-custom-header-nav-bar-acct-menu", isOpen: isOpen, onTriggerClick: onTriggerClick },
            React.createElement(UitkMenuTrigger, null, buttonText ? buttonTextComponent
                : showIcon && (React.createElement(UitkTertiaryButton, __assign({}, __assign(__assign({}, menuTriggerProps), { size: UitkButtonSize.LARGE })), showIcon && React.createElement(UitkIcon, __assign({}, iconProps))))),
            React.createElement(UitkMenuContainer, { position: position, width: 375, intersectionObserverRoot: "body", autoPosition: true },
                !isUserAuthenticated
                    && ((_d = globalComponentsContext.header.oneKey) === null || _d === void 0 ? void 0 : _d.oneKeyAccountMenu)
                    && isSignInPresent
                    ? (React.createElement(HeaderAccountMenuOneKey, { globalComponentsContext: globalComponentsContext, position: position, gssSigninRedirectParam: gssSigninRedirectParam, context: context, buttons: buttons, buttonsKeysPosition: buttonsKeysPosition })) : (isSignedInUser && !isSua ? (React.createElement(Experiment, { name: "GN_Member_Wallet_EGTnl" },
                    React.createElement(ExperimentControl, null,
                        React.createElement(HeaderSignedInHeading, { userFirstName: isLoyaltyPointsDisplayed ? formattedAccountInfo : globalComponentsContext.firstName, memberStatus: tierString })),
                    React.createElement(ExperimentVariant, { bucket: 1 },
                        React.createElement(LoyaltyMemberStatus, { skipSsr: true })),
                    React.createElement(ExperimentVariant, { bucket: 2 },
                        React.createElement(MemberWallet, { skipSsr: true }),
                        React.createElement("div", null,
                            React.createElement("hr", null))))) : (React.createElement(HeaderGuestHeading, { gssSigninRedirectParam: gssSigninRedirectParam, buttons: buttons, headerMenuIllustrationUrl: headerMenuIllustrationUrl, headingText: guestHeadingText, subHeadingText: guestSubheadingText, context: context }))),
                React.createElement("div", { className: "uitk-list" },
                    (acctMenuLinks || []).map(function (link) {
                        var _a, _b;
                        var isTaapLink = ((_a = link.menuItemSection) === null || _a === void 0 ? void 0 : _a.subSections) && ((_b = link.menuItemSection) === null || _b === void 0 ? void 0 : _b.subSections.length);
                        if (isTaapLink) {
                            return React.createElement(GcHeaderCustomMenuListItem, __assign({}, link, { key: link.id }));
                        }
                        return toMenuItem(link);
                    }),
                    isPickerEnabled
                        ? (React.createElement(Viewport, null,
                            React.createElement(ViewLarge, null),
                            React.createElement(ViewSmall, null,
                                React.createElement(React.Fragment, null,
                                    React.createElement(SharedUIPickerWrapper, { pickerTriggerPlacementType: PickerTriggerPlacementType.MENU_ITEM }),
                                    displayAlternativeLocale && React.createElement(HeaderAccountMenuLanguages, { locales: localeOptions, separator: false })))))
                        : isBexHeaderTemplate && (React.createElement(Viewport, null,
                            React.createElement(ViewLarge, null),
                            React.createElement(ViewSmall, null,
                                React.createElement(HeaderAccountMenuLanguages, { locales: localeOptions })))),
                    isSignedInUser && !isSua && (React.createElement(React.Fragment, null,
                        React.createElement("hr", null),
                        (signOutItems || []).map(toMenuItem))))))));
};
//# sourceMappingURL=header-account-menu.js.map